import { Client } from "@stomp/stompjs";
import { getLogger } from "../Logger";
import { GeneralSettings } from "..";

const stompLog = getLogger("core.messaging.StompLog");

export class Messaging {
    public static getClient(): Client {
        const result = new Client({ connectHeaders: { login: 'msg', passcode: GeneralSettings.get().messaging_passcode } });
        result.heartbeatOutgoing=65000
        result.brokerURL = GeneralSettings.get().messaging_url;
        if (stompLog.isDebugEnabled)
            result.debug = msg => stompLog.debug(msg);
        return result;
    }
}
